import React from 'react';
import Clients from './Clients';
import Catchphrase from './Catchphrase';
import Advantages from './Advantages';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import HomeContentSection from '../../Home/HomeContentSection/';

const useStyles = makeStyles(() => ({
  carousel: {
    paddingTop: 0
  },
}));

const Industry = (props) => {
  const classes = useStyles();
  return (
    <>
      <Advantages lang={props.lang} items={props.datas.advantages} active={0}/>
      {props.lang === 'en-CA' ? <Catchphrase catchphrase1="Digital signage captures the attention of 78% of people who are exposed to it, and 4 times more than a conventional poster." catchphrase2="Share quality content in real time on as many screens as you want." /> 
      : <Catchphrase catchphrase1="L’affichage dynamique capte l’attention de 78% des gens exposés et 4X plus qu’une affiche conventionnelle." catchphrase2="Diffusez du contenu de qualité en temps réel sur autant d'écrans que vous le souhaitez." />}
       <section className={classes.carousel}>
        <Container>
          <Clients lang={props.lang} items={props.datas}/>
        </Container>
      </section>
      <HomeContentSection lang={props.lang}/>
    </>
  );
}
  
export default Industry;